import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions' // 学习使用
import cart from './modules/cart' // 学习使用
import products from './modules/products' // 学习使用

import region from './modules/region' // 地理位置
import user from './modules/user'			// 用户登录相关信息
import roleFunc from './modules/roleFunc'	// 角色职能
import groupMember from './modules/groupMember'	// 组成员
import equipment from './modules/equipment'		// 电站详情-设备
import stationDetail from './modules/stationDetail'	// 电站详情
import stationConfig from './modules/stationConfig'	// 电站设置
import projectDetail from './modules/projectDetail'	// 项目详情
import deviceDetail from './modules/deviceDetail'	// 设备详情
import inbox from './modules/inbox' // 消息提醒
import alarmDetail from './modules/alarmDetail'	// 报警详情
import head from './modules/head'	// 头部
Vue.use(Vuex)

const store = new Vuex.Store({
  // actions,
  modules: {
    region,
    // cart,
    // products,
    head,
    user,
    roleFunc,
    groupMember,
    equipment,
    stationDetail,
    stationConfig,
    projectDetail,
    inbox,
    alarmDetail,
    deviceDetail
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js